import {
  MESSAGING_FETCH_REQUEST,
  MESSAGING_FETCH_REQUEST_SUCCESS,
  MESSAGING_FETCH_REQUEST_FAILURE,
  MESSAGING_ADD_REQUEST,
  MESSAGING_ADD_REQUEST_SUCCESS,
  MESSAGING_ADD_REQUEST_FAILURE,
  MESSAGING_UPDATE_REQUEST,
  MESSAGING_UPDATE_REQUEST_SUCCESS,
  MESSAGING_UPDATE_REQUEST_FAILURE,
  MESSAGING_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const messagingReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MESSAGING_FETCH_REQUEST:
    case MESSAGING_ADD_REQUEST:
    case MESSAGING_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MESSAGING_FETCH_REQUEST_SUCCESS:
    case MESSAGING_ADD_REQUEST_SUCCESS:
    case MESSAGING_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
        },
      });

    case MESSAGING_FETCH_REQUEST_FAILURE:
    case MESSAGING_ADD_REQUEST_FAILURE:
    case MESSAGING_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MESSAGING_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default messagingReducer;
